import React from 'react';

interface MenuButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = ({ onClick, isOpen = false }) => {
  return (
    <div className="header__menu ml-9">
      <button 
        onClick={onClick}
        className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-5"
        aria-label="Abrir menu"
        aria-expanded={isOpen}
      >
        <img
          src={require('../../../../assets/img/menu.svg').default}
          alt="Abrir menu"
          width="18"
          height="12"
          className="mr-3"
        />
        Menu
      </button>
    </div>
  );
};

export default MenuButton;